import { PushErrorOptions, faro } from "@grafana/faro-react";
import { isClientInitialized, shouldFaroBeEnabled } from "./initialize";

export function reportError(error: Error, pushErrorOptions?: PushErrorOptions) {
  if (!shouldFaroBeEnabled()) {
    return;
  }
  if (!isClientInitialized(faro)) {
    console.warn("Faro has not been initialized. Unable to report error.");
    return;
  }

  faro.api.pushError(error, pushErrorOptions);
}
